type AutoPlayToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
};

export default function AutoPlayToggle({
  checked,
  onChange,
  label,
}: AutoPlayToggleProps) {
  return (
    <label className="flex items-center gap-2 cursor-pointer mb-3 p-2 bg-gray-50 rounded-lg">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="w-4 h-4 text-indigo-600 bg-white border-gray-300 rounded focus:ring-indigo-500 cursor-pointer"
      />
      <span className="text-xs text-gray-700">{label}</span>
    </label>
  );
}
